import { styled as t, Box as i } from "@mui/material";
import a from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import { DEFAULT_ANIMATE_DURATION as c } from "../../temp-lib/constants/layout.js";
import u from "../assets/background-button-gray.png.js";
import { jsxs as p, jsx as o } from "react/jsx-runtime";
const d = t(a)`
  height: 55px;
  padding: 10px 25px;
  background-size: 100% 100%;
  transition: filter ${c}ms;
  .MuiButton-startIcon {
    z-index: 1; // todo: avoid icon cover by background component, but this may bring layout bug
  }
  &.MuiButton-text {
    font-weight: 400;
    font-size: 18px;
    color: white;
    text-transform: none;
  }
  &:hover {
    filter: brightness(1.2);
  }
  &:hover:active {
    filter: brightness(1);
  }
  &:disabled {
    filter: grayscale(1) brightness(0.58);
  }
  ${(n) => n.theme.breakpoints.up("res1024")} {
    min-width: 220px;
  }
`, e = t(i)`
  position: absolute;
  top: 0px;
  height: 100%;
  background-image: url(${`"${u}"`});
`, m = t(e)`
  left: 20px;
  width: calc(100% - 40px);
  background-position: top;
  background-size: 126% 100%;
`, l = t(e)`
  left: 0px;
  width: 20px;
  background-size: cover;
`, g = t(e)`
  right: 0px;
  width: 20px;
  background-position: 100%;
  background-size: cover;
`, h = t(i)`
  display: flex;
  position: relative;
  justify-content: center;
  white-space: nowrap;
`, C = (n) => {
  const {
    children: r,
    ...s
  } = n;
  return /* @__PURE__ */ p(d, {
    disableRipple: !0,
    ...s,
    children: [/* @__PURE__ */ o(m, {
      className: "Custom-Button-Background Custom-Middle"
    }), /* @__PURE__ */ o(l, {
      className: "Custom-Button-Background Custom-Left"
    }), /* @__PURE__ */ o(g, {
      className: "Custom-Button-Background Custom-Right"
    }), /* @__PURE__ */ o(h, {
      className: "Custom-Button-Content",
      children: r
    })]
  });
};
export {
  C as default
};
//# sourceMappingURL=ApeironButton.js.map
